export const COURSE_CATEGORIES = [
  { id: 1, name: "初診時医療面接" },
  { id: 2, name: "ブラッシング指導" },
  { id: 3, name: "歯磨剤" },
  { id: 4, name: "補助器具（フロス・歯間ブラシ・タフトブラシ）" },
  { id: 5, name: "マウスウォッシュ" },
  { id: 6, name: "電動歯ブラシ" },
  { id: 7, name: "ジェットウォッシャー" },
  { id: 8, name: "飲み物と食べ物・嗜好" },
  { id: 9, name: "喫煙・受動喫煙の状態" },
  { id: 10, name: "糖尿病" },
  { id: 11, name: "高血圧症・循環器疾患" },
  { id: 12, name: "複合アバター" },
] as const;

export type CourseCategory = (typeof COURSE_CATEGORIES)[number];

const CONDITION_CATEGORY_IDS_BY_COURSE: Record<number, readonly string[]> = {
  1: ["C1"],
  2: ["C3"],
  3: ["C10"],
  4: ["C4", "C5", "C8"],
  5: ["C6"],
  6: ["C7"],
  7: ["C9"],
  8: ["C12", "C13"],
  9: ["C14"],
  10: ["C15"],
  11: ["C16", "C17", "C18"],
  12: [],
};

export function conditionCategoryIdsForCourse(
  courseCategoryId: number,
): readonly string[] {
  return CONDITION_CATEGORY_IDS_BY_COURSE[courseCategoryId] ?? [];
}

export function isCompositeCourseCategory(courseCategoryId: number): boolean {
  return courseCategoryId === 12;
}

export function findCourseCategory(id: number): CourseCategory | undefined {
  return COURSE_CATEGORIES.find((category) => category.id === id);
}

export function buildLectureNumberMap(
  items: Array<{
    id: number;
    courseCategoryId: number | null;
    lectureOrder?: number | null;
  }>,
): Map<number, number> {
  const nextNumberByCategory = new Map<number, number>();
  const numberedItems: Array<[number, number]> = [];
  for (const item of sortLectureItems(items)) {
    if (
      !Number.isInteger(item.courseCategoryId) ||
      item.courseCategoryId === null
    ) {
      continue;
    }
    const lectureNumber =
      (nextNumberByCategory.get(item.courseCategoryId) ?? 0) + 1;
    nextNumberByCategory.set(item.courseCategoryId, lectureNumber);
    numberedItems.push([item.id, lectureNumber]);
  }
  return new Map(numberedItems);
}

export function sortLectureItems<
  T extends {
    id: number;
    courseCategoryId: number | null;
    lectureOrder?: number | null;
  },
>(items: T[]): T[] {
  return [...items].sort((left, right) => {
    const categoryDifference =
      (left.courseCategoryId ?? Number.MAX_SAFE_INTEGER) -
      (right.courseCategoryId ?? Number.MAX_SAFE_INTEGER);
    if (categoryDifference !== 0) return categoryDifference;
    const leftOrder =
      Number.isInteger(left.lectureOrder) && (left.lectureOrder ?? 0) > 0
        ? left.lectureOrder!
        : null;
    const rightOrder =
      Number.isInteger(right.lectureOrder) && (right.lectureOrder ?? 0) > 0
        ? right.lectureOrder!
        : null;
    if (leftOrder !== null || rightOrder !== null) {
      if (leftOrder === null) return 1;
      if (rightOrder === null) return -1;
      if (leftOrder !== rightOrder) return leftOrder - rightOrder;
    }
    return left.id - right.id;
  });
}
